import { doFetch } from "../utils/doFetch";

export const activateDataSync = async ({
    token,
}: {
    token?: string;
}) => {
    const response = await doFetch({
        url: `longformdatasyncservices/activateLongFormDataSync`,
        token,
      });
    return response;
};
